import { $t } from '@/i18n';
import widget from './registration';

import TopSwitch from './switch/TopSwitch';
import EnvForm from './switch/EnvForm';

widget.register('switch', {
  name: $t('k_9db94d9'),
  configComponent: null,
  viewComponent: TopSwitch,
});

widget.register('env', {
  name: $t('k_868fb9ab'),
  configComponent: EnvForm,
  viewComponent: TopSwitch,
});

export default widget;
